import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ItemService } from '../item.service';

@Component({
  selector: 'cc-item-percent',
  templateUrl: './item-percent.component.html',
  styleUrls: ['./item-percent.component.scss']
})
export class ItemPercentComponent implements OnInit, OnDestroy {
  @Input() form: FormGroup;

  constructor(private itemService: ItemService) {}

  ngOnInit() {
    this.itemService.addField(this.form, {
      percent: ''
    });
  }

  ngOnDestroy(): void {
    this.form.removeControl('percent');
  }
}
